//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
import { angularFileUpload } from 'angular';
import { IAbortablePromise, IPromiseService } from 'pinsights-js-shared';

import { IUploadMediaToLibraryResponse } from '@apis/media-library/mediaLibraryApiModel';
import CollectionId from '@models/CollectionId';
import { IWebGatewayErrorDto, RequestError } from '@utils/sessionFetch';

export class GatewayMediaUploadApiService {
  constructor(
    private readonly $upload: angularFileUpload.IUploadService,
    private readonly promiseService: IPromiseService,
  ) {}

  public uploadMediaToLibrary(
    media: File,
    collectionId?: CollectionId,
  ): IAbortablePromise<IUploadMediaToLibraryResponse> {
    return this.promiseService.processHttpResponse(
      this.$upload
        .upload<IUploadMediaToLibraryResponse>({
          url: `${CURALATE_ENV.WEB_GATEWAY_URL}/api/v1/media/library/add-by-bytes`,
          method: 'POST',
          data: { file: media },
          params: {
            collectionId,
          },
          headers: {
            'Upload-Length': media.size,
          },
        })
        .then(
          (x) => x,
          (e) => {
            const ex = e as IWebGatewayErrorDto;
            if (e.msg) {
              throw new RequestError(e.msg, e.errorId as string);
            }
            // Rethrow as-is if we can't identify the error type.
            throw e;
          },
        ),
    );
  }
}

angular
  .module('curalate')
  .service('GatewayMediaUploadApiService', [
    '$upload',
    'PromiseService',
    GatewayMediaUploadApiService,
  ]);
